import {
	postGuestBusinessDetails,
	type GuestBusinessDetailsPayload,
} from "@/api/guest-business-details";
import { userKeys } from "@/features/auth/keys";
import { getUserInformationOptions } from "@/features/auth/useGetUserInformation";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export type CreateGuestBusinessDetailsArgs = {
	locationId: number;
	guestId: number;
	payload: GuestBusinessDetailsPayload;
};

export default function useCreateGuestBusinessDetails(
	options?: MutationOptionsWithoutFn<void, CreateGuestBusinessDetailsArgs>,
) {
	const queryClient = useQueryClient();
	const { onSuccess: userOnSuccess, ...rest } = options ?? {};
	return useMutation({
		mutationFn: ({
			locationId,
			guestId,
			payload,
		}: CreateGuestBusinessDetailsArgs) =>
			postGuestBusinessDetails(locationId, guestId, payload),
		...rest,
		onSuccess: async (data, variables, context) => {
			await queryClient.invalidateQueries({
				queryKey: userKeys.userInformation(),
			});
			// Always network-fetch so consumers (including routes without an observer) see
			// fresh `guest_business_details` immediately after create.
			await queryClient.fetchQuery(getUserInformationOptions());
			userOnSuccess?.(data, variables, context);
		},
	});
}
